document.addEventListener('DOMContentLoaded', function(){

    // get all navs
    const navTabs = document.querySelectorAll('.nav-tabs');

    navTabs.forEach(nav => {

        // get all toggles
        const toggles = nav.querySelectorAll('[data-bs-toggle="pill"]');

        toggles.forEach(toggle => {

            // when tab is switches
            toggle.addEventListener('shown.bs.tab', event => {
                
                // get new active toggle
                const toCenterElement = event.target;

                // center it
                const leftOffset = toCenterElement.offsetLeft - (nav.getBoundingClientRect().width / 2) + (toCenterElement.getBoundingClientRect().width / 2);
                nav.scroll({
                    left: leftOffset,
                    behavior: 'smooth'
                });

            });

        });
    });

});